import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Direction } from "../../enums/Direction";

@Component({
    selector: 'tf-sort-by',
    templateUrl: 'sort-by.component.html',
    styleUrls: ['sort-by.component.scss']
})
export class TfSortByComponent implements OnChanges {

    @Input() sortBy: string | null = null;
    @Input() currentSortBy: string | null = null;
    @Input() direction: Direction | null = null;

    changed: boolean = false;
    order: string | null = null;

    @Output() onSort = new EventEmitter<any>();

    ngOnChanges(): void {
        if (this.currentSortBy != this.sortBy) {
            this.direction = null;
        }
    }

    getDirection() {
        return Direction;
    }

    sort() {
        if (this.direction == Direction.descending) {
            this.direction = Direction.ascending;
            this.emit();
            return;
        } else {
            this.direction = Direction.descending;
            this.emit();
            return;
        }

    }

    emit() {
        const data = {
            sortBy: this.sortBy,
            direction: this.direction
        };
        this.onSort.emit(data);
    }

    getClassesSortIcon(direction: Direction): string {

        if (this.direction == null) {
            return "";
        }
        if (this.direction == direction) {
            return "active";
        } else {
            return "inactive";
        }

    }

}
